import React from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";

const PrettoSlider = withStyles({
  root: {
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export default function CustomSlider({ sliderCb }) {
  //   const classes = useStyles();
  const [value, setValue] = React.useState(30);
  const [color, setColor] = React.useState("#d1958a");

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setColor(colors[Math.floor(value / 10)]);
    sliderCb(value);
    // sliderCb(colors[Math.floor(value / 10)]);
  };
  const colors = [
    "#ffeeeb",
    "#f5dad5",
    "#ecbcb4",
    "#e3b1a8",
    "#d1958a",
    "#d18e82",
    "#b3776d",
    "#916057",
    "#5c3d37",
    "#5e3f3a",
  ];

  return (
    <div>
      <PrettoSlider
        value={value}
        onChange={handleChange}
        style={{ color: `${color}`, marginTop: "2vh" }}
        defaultValue={20}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Slider.js